import script from "./UnitTable.vue?vue&type=script&setup=true&lang=js"
export * from "./UnitTable.vue?vue&type=script&setup=true&lang=js"

import "./UnitTable.vue?vue&type=style&index=0&id=5bd24e88&lang=scss"
import "./UnitTable.vue?vue&type=style&index=1&id=5bd24e88&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bd24e88"]])

export default __exports__